import React, { useEffect, useState } from "react";
import "./AssignOrderlist.css";
import {
  Dialog,
  DialogContent,
  Grid,
  Typography,
  IconButton,
  DialogTitle,
  DialogActions,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Link,
  Tooltip,
  Input,
  CircularProgress,
  Autocomplete,
  TextField,
} from "@mui/material";

import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { useDispatch, useSelector } from "react-redux";
import { API_URL, backend } from "../../../config";

import { initialize_cart_action } from "./../../../redux/actions/cart";
import { set_customer_action } from "./../../../redux/actions/customer";

const AssignOrderlist = (props) => {
  const { data, type = 1 } = props;
  const dispatch = useDispatch();

  const cartStore = useSelector((state) => state.cart);
  const customerStore = useSelector((state) => state.customer);
  const currentUserStore = useSelector((state) => state.current_user);

  const [open, setOpen] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [companyLocations, setCompanyLocations] = useState([]);
  const [orderlists, setOrderlists] = useState([]);
  const [orderlistsLoaded, setOrderlistsLoaded] = useState(false);
  const [selectedOrderlist, setSelectedOrderlist] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [loading, setLoading] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleCustomerChange = (e, v) => {
    if (!Object.keys(cartStore).includes("" + v.id)) {
      dispatch(initialize_cart_action([], v));
    }

    dispatch(set_customer_action(v));
    setOrderlists([]);
    setOrderlistsLoaded(false);
  };

  useEffect(() => {
    if (!open) return;

    const fetchOrderlists = async () => {
      setLoading(true);
      const companyId = customerStore?.company_id;
      if (!companyId) {
        setLoading(false);

        return;
      }

      await backend
        .get(
          `${API_URL}orderlists?no_page=1&visible=True&company_id=${companyId}`,
        )
        .then(({ data }) => {
          setOrderlists(data || []);
          setOrderlistsLoaded(true);

          if (data.length === 1) {
            setSelectedOrderlist(data[0].id);
          }
          setLoading(false);
        })
        .catch((e) => {
          console.error(e);
          setLoading(false);
        });
    };

    const fetchCustomers = async () => {
      setLoading(true);

      await backend
        .get(`${API_URL}users?no_page=1`)
        .then(({ data }) => {
          const dataMap = data
            .filter((item) => item.is_active && item.company)
            .map((item) => {
              const customerCompanyLocations = item.company
                ? companyLocations.filter(
                    (clItem) => clItem.company_id === item.company,
                  )
                : [];

              const customerCompanyLocationsId = customerCompanyLocations.map(
                (clItem) => clItem.id,
              );

              return {
                id: item.id,
                name: item.username,
                company_id: item.company,
                company_location: customerCompanyLocationsId,
                company_location_data: customerCompanyLocations,
              };
            });

          setCustomers(dataMap);
          setLoading(false);
        })
        .catch((e) => {
          console.error(e);
          setLoading(false);
        });
    };

    const companyLocationsGet = async () => {
      setLoading(true);
      await backend
        .get(`${API_URL}companylocations?no_page=1`)
        .then(({ data }) => {
          const dataMap = data.filter((item) => item.active);
          setCompanyLocations(dataMap);
          setLoading(false);
        })
        .catch((e) => {
          console.error(e);
          setLoading(false);
        });
    };

    if (customerStore && !orderlistsLoaded) {
      fetchOrderlists();
    }

    if (currentUserStore?.is_staff) {
      if (!companyLocations.length) {
        companyLocationsGet();
      }

      if (companyLocations.length && !customers.length) {
        fetchCustomers();
      }
    }
  }, [
    open,
    companyLocations,
    customers,
    customerStore,
    currentUserStore,
    orderlistsLoaded,
  ]);

  useEffect(() => {
    if (!selectedOrderlist) setSelectedCategory("");
    setLoading(false);
  }, [selectedOrderlist]);

  const handleAssign = async () => {
    if (!selectedOrderlist || !selectedCategory) return;

    try {
      await backend.post(
        `${API_URL}orderlists/${selectedOrderlist}/addproduct/`,
        { upc: data.upc, category_name: selectedCategory },
      );
      handleClose();
    } catch (e) {
      console.error(e);
    }
  };

  const orderlistObj = orderlists.find((o) => o.id === selectedOrderlist) || {};

  return (
    <>
      {type === 1 ? (
        <Button
          variant="contained"
          color="info"
          onClick={handleOpen}
          className="add-to-guide-button"
        >
          Add to Guide
        </Button>
      ) : (
        <Tooltip title="Assign to Order Guide">
          <IconButton onClick={handleOpen} className="add-to-guide-button">
            <OpenInNewIcon />
          </IconButton>
        </Tooltip>
      )}
      <Dialog
        onClose={handleClose}
        open={open}
        fullWidth
        maxWidth="sm"
        className="assign-orderlist-dialog"
      >
        <DialogTitle>Add product to Order Guide</DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="subtitle1">{data.name}</Typography>
            </Grid>
            {loading ? (
              <Grid item xs={12}>
                <div style={{ textAlign: "center" }}>
                  <CircularProgress />
                  <div>Loading information...</div>
                </div>
              </Grid>
            ) : (
              <>
                {customers.length > 0 && (
                  <Grid item xs={6}>
                    <FormControl fullWidth>
                      <InputLabel shrink id="ol-select-label">
                        Customer
                      </InputLabel>
                      <Autocomplete
                        fullWidth
                        disableClearable
                        name="customer"
                        options={customers}
                        getOptionLabel={(option) =>
                          option !== null ? `${option.name}` : ""
                        }
                        renderInput={(params) => (
                          <TextField {...params} variant="standard" />
                        )}
                        isOptionEqualToValue={(option, value) =>
                          option.id === value.id
                        }
                        value={customerStore}
                        onChange={(e, value) => handleCustomerChange(e, value)}
                        style={{ marginTop: 14 }}
                      />
                    </FormControl>
                  </Grid>
                )}
                {!selectedOrderlist && customerStore && (
                  <Grid item xs={6}>
                    <FormControl fullWidth>
                      <InputLabel shrink id="ol-select-label">
                        Order Guide
                      </InputLabel>
                      <Select
                        labelId="ol-select-label"
                        input={<Input />}
                        size="small"
                        value={selectedOrderlist}
                        label="Order Guide"
                        onChange={(e) => setSelectedOrderlist(e.target.value)}
                      >
                        {orderlists.map((ol) => (
                          <MenuItem key={ol.id} value={ol.id}>
                            {ol.company_location_name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                )}
                {orderlistObj?.categories && (
                  <Grid item xs={6}>
                    <FormControl fullWidth>
                      <InputLabel shrink id="cat-select-label">
                        Category
                      </InputLabel>
                      <Select
                        labelId="cat-select-label"
                        size="small"
                        input={<Input />}
                        value={selectedCategory}
                        label="Category"
                        onChange={(e) => setSelectedCategory(e.target.value)}
                      >
                        {(orderlistObj.categories || []).map((cat) => (
                          <MenuItem
                            key={cat.category_name}
                            value={cat.category_name}
                          >
                            {cat.category_name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                )}
                {customerStore?.company_location?.[0] && (
                  <Grid item xs={12}>
                    <Typography
                      variant="body2"
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "6px",
                      }}
                    >
                      <span>Manage categories/products:</span>
                      <Link
                        href={
                          customerStore?.company_location?.[0]
                            ? `/customer/${customerStore.company_location[0]}/orderlists`
                            : "/orderlistPrototype"
                        }
                        target="_blank"
                      >
                        <OpenInNewIcon fontSize="small" />
                      </Link>
                    </Typography>
                  </Grid>
                )}
              </>
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="error" variant="outlined">
            Close
          </Button>
          <Button onClick={handleAssign} color="primary" variant="contained">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AssignOrderlist;
